var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteTestResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.4931mm",
    height: "4.3659mm",
    viewBox: "0 0 4.4931 4.3659",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.06 -158.78)",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    d: "m131.52 158.25h5.2917v5.2917h-5.2917z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.8 161.07 1.2496 0.0376c0.0334 0.17039 0.11444 0.38058 0.29265 0.59544 0.16926 0.20407 0.39289 0.29002 0.53436 0.32748l-4e-3 0.67066c-1e-3 0.1712-0.17701 0.30903-0.39687 0.30903h-1.6756c-0.21987 0-0.39688-0.13783-0.39688-0.30903v-1.3221c0-0.1712 0.17711-0.31564 0.39688-0.30903z",
    fill: "none",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.52 158.78h2.2331c0.21352 0 0.38894 0.16933 0.39635 0.38259l0.0407 0.5677c1e-3 0.0343-0.68011 0.0773-0.93167 0.42665-0.28164 0.39109-0.13867 1.091-0.17724 1.0924h-1.895c-0.073 0-0.13229-0.0593-0.13229-0.1323v-5e-3l0.0699-1.9497c7e-3 -0.21326 0.18283-0.38259 0.39635-0.38259z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.23,
    cy: 160.9,
    r: 1.1906,
    fill: "none",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.58 160.51c-0.0185-0.0177-0.0489-0.0177-0.0675 0l-0.38126 0.44265-0.25665-0.22014c-0.0185-0.0175-0.037-0.0175-0.0556 0l-0.10716 0.10848c-0.0185 0.0175-0.0185 0.0468 0 0.0643l0.38974 0.37201c0.0185 0.0177 0.0489 0.0177 0.0675 0l0.51065-0.60457c0.0183-0.0177 0.0183-0.0384 0-0.0561z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTestResults);
export default __webpack_public_path__ + "static/media/white_test_results.337daa8c4ea8be48a3b5d65dc8c13a63.svg";
export { ForwardRef as ReactComponent };